import React, { Fragment, useContext } from "react";
import {Link} from "react-router-dom";
import {getTeamRouterLink} from "root/Wieldy/routePaths";

import './TeamDetailSidebarEntry.scss'

const TeamDetailSidebarEntry = (props) =>
{
    const activeClassName = props.active ? ' active' : '' ;

    const onClick = () =>
    {
        props.onClick ( props.name ) ;
    }

    return (
        <Fragment>
            <li className={"dt-side-nav__item team " + activeClassName} key={props.keyName}>
                <Link onClick={onClick} className="dt-module-side-nav__link" to={getTeamRouterLink(props.teamDetails.team_id, 'users')}>
                    <i className="icon icon-avatar icon-fw icon-xl"/>
                    <span className="dt-module-side-nav__text">{props.teamDetails.team_name}</span>
                </Link>
            </li>
        </Fragment>
    )
}
export default TeamDetailSidebarEntry;